import { t } from "@/i18n-js/instance";
import { ActionModal } from "@circle-react-shared/ModalsV2/ActionModal";
import { Button } from "@circle-react-uikit/Button";
import { Form } from "@circle-react-uikit/Form";
import { LoginMessage } from "./LoginMessage";
import { usePublicLiveStore, usePublicLiveStoreActions } from "./store";

interface PreJoinModalProps {
  isOpen: boolean;
}

export const PreJoinModal = ({ isOpen }: PreJoinModalProps) => {
  const { setGuestName, setIsGuestPromptOpen } = usePublicLiveStoreActions();
  const {
    guest: { name },
  } = usePublicLiveStore();

  const defaultFormValues = {
    name,
  };

  const onSubmit = (formValues: { name: string }) => {
    setGuestName(formValues.name);
    setIsGuestPromptOpen(false);
  };

  return (
    <ActionModal
      size="sm"
      title={t("public_live_stream.pre_join.join_stream_title")}
      isOpen={isOpen}
      contentPortalId="prejoin-modal"
    >
      <Form
        onSubmit={onSubmit}
        defaultValues={defaultFormValues}
        className="w-full"
      >
        <Form.Item
          hideDescription
          hideBorder
          fullWidth
          hideLabel
          name="name"
          placeholder={t("public_live_stream.pre_join.your_name")}
          rules={{
            required: t("messaging.validations.room_name_required"),
            maxLength: {
              value: 80,
              message: t("messaging.validations.room_name_max_length"),
            },
          }}
        >
          <Form.Input autoFocus />
        </Form.Item>
        <Button full large className="my-4" variant="circle">
          {t("public_live_stream.pre_join.join_stream")}
        </Button>
      </Form>
      <div className="mb-6 mt-3 text-center">
        <LoginMessage buttonTextColor="text-dark" />
      </div>
    </ActionModal>
  );
};
